import React from "react";

export default function Loader() {
    return (
    <>
        <div className="preloader">
            <div className="preloader-inner">
                <div className="preloader-icon">
                    <div className="spinner"></div>
                </div>
                <div className="preloader-text">Loading...</div>
            </div>
        </div>
        <style jsx="true">{`
            .spinner {
                width: 40px;
                height: 40px;
                border: 4px solid rgba(0, 0, 0, 0.1);
                border-top-color: #3498db;
                border-radius: 50%;
                animation: spin 1s linear infinite;
                margin: 0 auto;
            }

            @keyframes spin {
                to {
                    transform: rotate(360deg);
                }
            }
        `}</style>
    </>
    );
}